/* global _,NameParse */
(function () {
  'use strict';

  // Add onto the wsLrs.cards module...
  angular.module('wsLrs.cards').factory("ViewUtils", [function () {
    return {
      makeBullet: function makeBullet(question, maxAverageTimeCentiseconds) {
        if (question.averageDurationCentiseconds) {
          return {
            data: {
              // values expected to be in centiseconds
              max: maxAverageTimeCentiseconds,
              value: question.averageDurationCentiseconds
            }
          };
        } else {
          return null;
        }
      }
    };
  }]).directive("wsTitleView", [function () {
    return {
      templateUrl: "modules/app/views/section-title.html",
      scope: {
        /*
        titleData: {
            title: {
                text: "",
                emphasized: boolean (bold),
                main: boolean (blue) (only works if emphasized is also true)
            },
            subtitle: "", (text of any subtitle)
            subtitleData: { (won't be shown if subtitle is present)
                count: Integer,
                total: Integer,
                people: (people or person)
                verb: (Past tense verb),
                correctAnswersGroups: ["answer1", "answer2"]
                (This will look like "<count> out of <total> <people> correctly <verb> [correctAnswer in correctAnswerGroup]")
            }
        }
         */
        titleData: "="
      }
    };
  }]).directive("wsLeaderboardView", ["$controller", "$q", "wsPaginate", "wsTimelineChart", function ($controller, $q, Paginate, TimelineChart) {
    return {
      template: '<div ng-include="templateUrl"></div>',
      scope: {
        /*
        data: Required. The raw data used to build the leaderboard (data.allAttempts.results)
        templateUrl: the name of the html file that has the desired leaderboard html
        sortControls: array of table sort controls
        orderByCallback: optional. a function to extend the orderBy logic in wsPaginate to include other values
        timelineCallback: a function that returns the results of the InteractionTimelineTransformer for the current page of results.
            should return an object with element "data" that has the response.
        timelineUniqueId: set this value to the property name in your data that holds the person/unique Id
        companyName: optional. Used to build title if title isn't specified
        sortBy: default value to sort by
        title: {
             text: text of any title to be displayed,
             emphasized: option for displaying the title (bold),
             main: option for displaying the title (blue) (only works if emphasized is also true)
        }
        listerControls: Any lister or search parameters that need to be passed in. See the wsLister for those
         */
        definition: "="
      },
      link: function link(scope) {
        if (scope.definition) {
          scope.rawData = scope.definition.data;
          scope.templateUrl = scope.definition.templateUrl;
          scope.sortControls = scope.definition.sortControls;
          scope.timelineCallback = scope.definition.timelineCallback;
          scope.companyName = scope.definition.companyName;
          scope.sortBy = scope.definition.sortBy;
          scope.orderByCallback = scope.definition.orderByCallback;
          scope.timelineUniqueId = scope.definition.timelineUniqueId;
          scope.helpText = scope.definition.helpText;
        }
        scope.showHowToRead = false;
        var allAttempts = scope.rawData.allAttempts.results,
          companyName = scope.companyName || "",
          parser = new NameParse();
        scope.definition.title = scope.definition.title || {
          text: companyName + " Leaderboard",
          emphasized: true,
          main: true
        };
        angular.forEach(allAttempts, function (data) {
          data.name = data.name; // Can be a num, so force to string
          data.idName = data.name ? data.name.replace(/\s+/g, '') : "";
          data.parsedName = data.name ? parser.parse(data.name) : "";
        });

        //set this value to true until timeline loads
        scope.timelineLoading = true;
        function fetchData(params) {
          return Paginate.fetchData(params, allAttempts, scope.orderByCallback).then(function (results) {
            if (results.scoreType !== undefined) {
              scope.scoreType = results.scoreType;
            }
            return TimelineChart.createMulti(results.results, scope.timelineUniqueId, scope.timelineCallback).then(function () {
              scope.timelineLoading = false;
              return results;
            });
          });
        }
        if (scope.definition.listerControls) {
          _.defaults(scope, scope.definition.listerControls);
        }
        Paginate.setupPaging(scope, fetchData);
      }
    };
  }]).factory("AssessmentsDetails", ["ViewUtils", "Utils", "wsQuestionCharts", function (ViewUtils, Utils, QuestionCharts) {
    return {
      getPossibleResponses: function getPossibleResponses(correctResponses, interactionType, allResponses) {
        return _.reduce(correctResponses, function (memo, correctResponsePattern) {
          // strip {param} "characterstring parameters" from response patterns
          // They are only valid for fill-in, long-fill-in, and performance string responses, but since
          // we aren't validating statements here, just strip them off the beginning of each response
          var splitResponses = correctResponsePattern.split("[,]"),
            result;
          var csp = /^(?:(?:\{(case_matters|order_matters)\=(true|false)\})|(?:\{lang\=\w+\}))*/;
          splitResponses = _.map(splitResponses, function (resp) {
            return resp.replace(csp, '');
          });
          if (interactionType === "fill-in" || interactionType === "long-fill-in" || interactionType === "other") {
            result = splitResponses;
          } else if (interactionType === "likert" || interactionType === "true-false" || interactionType === "choice" || interactionType === "sequencing") {
            result = _.reduce(splitResponses, function (memo, response, index) {
              var splitResponse = response.split("[.]"),
                fullResponse = _.findWhere(_.flatten(allResponses, true), {
                  id: splitResponse[0]
                });
              memo[splitResponse[1] || index] = fullResponse === undefined ? splitResponse[0] : fullResponse.description;
              return memo;
            }, []);
          } else if (interactionType === "numeric") {
            var limits = correctResponsePattern.split("[:]");
            if (limits.length === 2) {
              if (limits[0] === "" && limits[1] === "") {
                result = "any value";
              } else if (limits[0] === "") {
                result = [limits[1] + " or less"];
              } else if (limits[1] === "") {
                result = [limits[0] + " or more"];
              } else {
                result = ["between " + limits[0] + " and " + limits[1]];
              }
            } else {
              result = [limits[0]];
            }
          }
          result = _.map(result, function (r) {
            return _.isUndefined(r) ? "undefined" : Utils.decodeHtmlEntity(r);
          });
          memo.push(result);
          return memo;
        }, []);
      },
      defineItem: function defineItem(questionData, question, difficultyResultList, maxTime, cardId, hideIndividualAnswers, downloadUrl, surveyMode, config) {
        var self = this;
        return {
          data: _.reduce(questionData, function (m, v, k) {
            m[k] = _.findWhere(v.results, {
              activityId: question.activityId,
              description: Utils.decodeHtmlEntity(question.description),
              interactionType: question.interactionType
            });
            return m;
          }, {}),
          bullet: ViewUtils.makeBullet(question, maxTime),
          maxTime: maxTime,
          difficulty: _.findWhere(difficultyResultList, {
            description: question.description
          }),
          filters: {
            activityIds: {
              ids: [question.activityId]
            }
          },
          questionId: question.activityId,
          cardId: cardId,
          isQuestion: true,
          hideIndividualAnswers: hideIndividualAnswers,
          downloadUrl: downloadUrl,
          surveyMode: surveyMode,
          config: config,
          updateChartData: function updateChartData() {
            var data = this.data.allAttempts;
            if (!data) {
              return;
            }
            data.interactionType = data.interactionType.toLowerCase();
            this.title = {
              text: Utils.stripHTML(Utils.decodeHtmlEntity(data.description)),
              emphasized: true
            };
            this.subtitleData = {
              count: data.correctUserCount,
              total: data.userCount,
              verb: "answered correctly",
              multipleAnswers: data.interactionType === "choice",
              correctAnswersGroups: self.getPossibleResponses(data.correctResponses, data.interactionType, data.responses),
              people: data.correctUserCount === 1 ? "person" : "people"
            };
            if (data.correctResponses && data.correctResponses.length) {
              if (data.interactionType === "sequencing") {
                this.subtitleData.verb = "correctly sequenced";
              } else if (data.interactionType === "matching") {
                this.subtitleData.verb = "matched correctly";
              } else if (data.interactionType === "choice") {
                this.subtitleData.verb = "correctly chose";
              } else if (data.interactionType === "true-false") {
                this.subtitleData.verb = "correctly chose";
              } else {
                this.subtitleData.verb = "correctly answered";
              }
            }
            if (data.interactionType === "other") {
              this.subtitleData.verb = "participated";
            }
            if (data.interactionType === "likert" || this.surveyMode === true) {
              this.subtitleData.count = data.userCount;
              this.subtitleData.people = data.userCount === 1 ? "person" : "people";
              this.subtitleData.verb = "answered";
              this.subtitleData.correctAnswersGroups = null;
              this.difficulty = false;
            }
            if (data.interactionType === "activity") {
              data.responses = data.responses || [{
                id: "correct",
                description: "Correct",
                count: data.correctUserCount,
                successCount: data.correctUserCount
              }, {
                id: "incorrect",
                description: "Incorrect",
                count: data.totalCount - data.correctUserCount,
                successCount: 0
              }];
            }
            this.height = 200;
            if (QuestionCharts.hasOwnProperty(data.interactionType)) {
              QuestionCharts[data.interactionType](this, data, this.surveyMode, this.config);
            }
          }
        };
      },
      makeQuestions: function makeQuestions(questionData, difficultyData, cardId, isActivity, hideIndividualAnswers, downloadUrl, surveyMode, config) {
        var ret = [];
        var difficultyResultList = [],
          maxAverageTimeCentiseconds = _.max(questionData.allAttempts.results, function (d) {
            return d.averageDurationCentiseconds;
          }).averageDurationCentiseconds,
          self = this;
        if (difficultyData) {
          difficultyResultList = difficultyData.result.allAttempts.results.questionResults;
        }
        angular.forEach(questionData.allAttempts.results, function (question) {
          if (isActivity && question.interactionType === "activity") {
            ret.push(self.defineItem(questionData, question, difficultyResultList, maxAverageTimeCentiseconds, cardId, false, downloadUrl, surveyMode, config));
          } else if (!isActivity) {
            ret.push(self.defineItem(questionData, question, difficultyResultList, maxAverageTimeCentiseconds, cardId, hideIndividualAnswers, downloadUrl, surveyMode, config));
          }
        });
        return ret;
      }
    };
  }]).directive("wsActivityDetailsView", ["AssessmentsDetails", "wsPaginate", function (AssessmentsDetails, Paginate) {
    return {
      templateUrl: "modules/app/views/activity-table.html",
      scope: {
        /*
        definition: {
            questionData: Results from the ASSESSMENTS transformer,
            helpText: Optional. Any descriptive text to explain the table to the user,
            sortControls: Definition of the header and sort controls for the table. Same as the normal lister sortControls
        }
         */
        definition: "="
      },
      link: function link(scope) {
        var questionData = scope.definition.questionData.allAttempts.results,
          activities = _(questionData).chain().filter(function (d) {
            return d.interactionType === "activity";
          }).reduce(function (m, k) {
            var activity = _.extend({}, k);
            activity.name = activity.description ? activity.description : activity.activityId;
            m.push(activity);
            return m;
          }, []).value();
        scope.activityCount = activities.length;
        function fetchData(params) {
          return Paginate.fetchData(params, activities).then(function (response) {
            return response;
          });
        }
        scope.sortControls = scope.definition.sortControls;
        Paginate.setupPaging(scope, fetchData);
        scope.loaded = true;
      }
    };
  }]).directive("wsQuestionDetailsView", ["AssessmentsDetails", function (AssessmentsDetails) {
    return {
      templateUrl: "modules/app/views/question-details.html",
      scope: {
        /*
        definition: {
            questionData: Results from the ASSESSMENTS transformer
            difficultyData: Results from the DIFFICULTY transformer
            cardId: Id of the current card,
            hideIndividualAnswers,
            downloadUrl: url to download all interactions associated with this card,
            surveyMode
            config: used to retrieve card specific custom chart colors
        }
         */
        definition: "="
      },
      link: function link(scope) {
        var questionData = scope.definition.questionData,
          difficultyData = scope.definition.difficultyData;
        scope.questions = AssessmentsDetails.makeQuestions(questionData, difficultyData, scope.definition.cardId, false, scope.definition.hideIndividualAnswers, scope.definition.downloadUrl, scope.definition.surveyMode, scope.definition.config);
        if (scope.questions.length === 0) {
          //We could fail to make any question charts so we need to hide this section
          scope.definition.hide = true;
        }
        var anyHasDuration = _.some(scope.questions, function (q) {
          return q.maxTime > 0;
        });
        _.each(scope.questions, function (q) {
          q.anyHasDuration = anyHasDuration;
        });
        scope.questionDisplay = [];
        scope.questionDisplayCallback = function questionDisplayCallback(page) {
          scope.questionDisplay = page;
        };
      }
    };
  }]).factory("wsPaginate", ["$q", "$controller", function ($q, $controller) {
    return {
      setupPaging: function setup(scope, fetchData, fetchSearchSuggestions) {
        scope.defaultSortBy = scope.sortBy || "name";
        scope.scoreType = "best";
        $controller('ListerBaseCtrl', {
          $scope: scope
        });
        scope.$watch('timelineLabel', function (newValue) {
          if (newValue) {
            var lastColumn = scope.sortControls.length - 1;
            scope.sortControls[lastColumn].title = scope.timelineLabel;
          }
        }, true);
        scope.getScoreSort = function (sortBy, scoreType) {
          return (sortBy.lastIndexOf('-', 0) === 0 ? '-' : '') + "scores-" + scoreType;
        };
        scope.fetchData = fetchData;
        scope.fetchSearchSuggestions = fetchSearchSuggestions || scope.fetchData;
      },
      //orderByCallback is optional
      fetchData: function fetchData(params, data, orderByCallback) {
        /*jshint camelcase: false */
        var deferred = $q.defer();
        var limit = params._limit || params.limit || 10,
          offset = params._offset || 0;
        var vals = _.clone(data);

        //if a row in data is marked selected = true, it will always show at the top
        var selected = _.find(vals, function (val) {
          return val.selected;
        });
        if (selected) {
          vals = _.reject(vals, function (val) {
            return val === selected;
          });
          limit = limit - 1;
          offset = offset !== 0 ? offset - 1 : 0;
        }
        vals = _.values(vals);
        if (params.in_name) {
          var lowerParam = params.in_name.toLowerCase();
          vals = _.filter(vals, function (statement) {
            if (statement.name) {
              return statement.name.toLowerCase().indexOf(lowerParam) > -1;
            }
            return 0;
          });
        }
        var scoreType = '';
        var getOrderBy = function getOrderBy(v) {
          return _.isNumber(v) ? v : -Infinity;
        };
        if (params.order_by) {
          //by default, data will be sorted by the exact field name passed into params.order_by
          var orderBy = params.order_by,
            reverse = false;
          if (orderBy.lastIndexOf("-", 0) === 0) {
            orderBy = orderBy.substring(1, orderBy.length);
            reverse = true;
          }
          if (orderBy.indexOf("scores") > -1) {
            scoreType = orderBy.substring(orderBy.lastIndexOf("-") + 1);
            orderBy = function orderBy(val) {
              if (scoreType === "best") {
                return getOrderBy(val.scores.Best);
              } else if (scoreType === "last") {
                return getOrderBy(val.scores.Recent);
              } else if (scoreType === "first") {
                return getOrderBy(val.scores.First);
              }
              return getOrderBy(val.score);
            };
          }
          if (orderBy === "last") {
            orderBy = function orderBy(val) {
              if (val.parsedName.lastName) {
                return val.parsedName.lastName.toLowerCase();
              }
              return "";
            };
          }
          if (orderBy === "name") {
            orderBy = function orderBy(val) {
              if (val.name) {
                return val.name.toLowerCase();
              }
              return "";
            };
          }

          //do any custom orderBy logic, if it exists
          if (orderByCallback) {
            orderBy = orderByCallback(orderBy);
          }
          if (orderBy && _.isArray(orderBy)) {
            for (var i = 0; i < orderBy.length; i++) {
              vals = _.sortBy(vals, orderBy[i], {
                reverse: reverse
              });
            }
          } else {
            vals = _.sortBy(vals, orderBy, {
              reverse: reverse
            });
          }
          if (reverse) {
            vals.reverse();
          }
        }
        var numResults = _.size(vals);
        vals = vals.slice(offset, limit + offset);

        //if a row in data is marked selected = true, it will be added to show at the top
        if (selected) {
          vals = [selected].concat(vals);
          numResults = numResults + 1;
        }
        deferred.resolve({
          "results": vals,
          "count": numResults,
          scoreType: scoreType
        });
        return deferred.promise;
        /*jshint camelcase: true */
      }
    };
  }]).directive("wsSentenceView", [function () {
    return {
      templateUrl: "modules/app/views/sentence.html",
      scope: {
        /*
        definition: {
            selectedGroupName: "", (name to be used as a header)
            sentences: ["", ""] (lines to be displayed)
        }
         */
        definition: "="
      }
    };
  }]).directive("wsHelpText", ["$sce", function ($sce) {
    return {
      templateUrl: "modules/app/views/help-text.html",
      scope: {
        /*
        helpText: either a string that will be rendered verbatim, or an object that looks like:
         {
            templateUrl: URL of the path to find the HTML template
            Any variables that the template needs for rendering, set by the caller.
            Reference them within the template by helpText.varName
         }
         */
        helpText: "="
      },
      link: function link(scope) {
        scope.showTemplate = angular.isObject(scope.helpText);
        scope.showHowToRead = false;
        var viewType = scope.showTemplate ? scope.helpText.viewType : "chart";
        scope.helpTitle = scope.helpText && scope.helpText.helpTitle ? scope.helpText.helpTitle : "How to read this " + viewType;
        scope.detailHelpText = scope.showTemplate ? scope.helpText.detailText : scope.helpText;
        scope.renderHtml = function (html) {
          return $sce.trustAsHtml(html.replace(/\r\n?/g, '<br>'));
        };
      }
    };
  }]);
})();
